




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ImportPage from "@/lib/import-page";
import { mixins } from "vue-class-component";

@Component({
  components: {},
})
export default class ImportBin extends mixins(ImportPage, AbpBase) {
  importPageName = "Bin";
  //filters
  current: number = 0;
  binFileId: number = 0;
  spinShow: boolean = false;
  get store() {
    return this.$store.state.binImport;
  }
  get countItems() {
    return this.$store.state.binImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.binImport.countImportedItems;
  }
  get list() {
    return this.$store.state.binImport.itemsImported;
  }
  get loading() {
    return this.$store.state.binImport.loading;
  }
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "binImport/export",
      data: this.binFileId,
    });
  }
  renderErrorMsgElements(errorMessage: string) {
    return Util.renderErrorMsgElements(errorMessage);
  }
  columns = [
    {
      title: this.L("ErrorMsg"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("Code"),
      width: 150,
      key: "binCode",
    },
    {
      title: this.L("Type"),
      width: 100,
      key: "binType",
    },
    {
      title: this.L("Level"),
      width: 100,
      key: "level",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.level));
      },
    },
    {
      title: this.L("Aisle"),
      width: 100,
      key: "aisleCode",
    },
    {
      title: this.L("MaxNumOfSku"),
      width: 100,
      key: "maxNumOfSku",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.maxNumOfSku));
      },
    },
    {
      title: this.L("Vol"),
      width: 100,
      key: "vol",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.vol));
      },
    },
    {
      title: this.L("Length"),
      width: 100,
      key: "length",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.length));
      },
    },
    {
      title: this.L("Width"),
      width: 100,
      key: "width",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.width));
      },
    },
    {
      title: this.L("Height"),
      width: 100,
      key: "height",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.height));
      },
    },
    {
      title: this.L("IsImported"),
      width: 80,
      fixed: "right",
      key: "isImported",
      align: "center",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Bin", (notification) => {
        this.processNotifierImportBin(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Bin", (notification) => {
          this.processNotifierImportBin(notification);
        });
      });
    }
  }

  processNotifierImportBin(notification: any) {
    if (
      !Util.isNull(notification.binFileId) &&
      notification.binFileId == this.binFileId
    ) {
      this.$store.commit({
        type: "binImport/processNotifier",
        data: notification,
      });
    }
  }
  resetList() {
    this.$store.commit({
      type: "binImport/resetList",
    });
  }

  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("binImport/uploadImportBinFile", data)
          .then((res) => {
            this.resetList();
            this.activeStep(true);
            this.binFileId = res;
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
